var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container", staticStyle: { overflow: "hidden" } },
    [
      _c("div", { staticClass: "detail-header" }, [
        _c("div", { staticClass: "header-left" }, [
          _c(
            "span",
            {
              staticStyle: {
                "font-size": "16px",
                "font-weight": "bold",
                color: "#333"
              }
            },
            [
              _vm._v(
                _vm._s(_vm.childData.areaName) +
                  " " +
                  _vm._s(
                    _vm.childData.areaName !== _vm.childData.areaGroupName
                      ? _vm.childData.areaGroupName
                      : ""
                  ) +
                  _vm._s(_vm.childData.garageName)
              )
            ]
          )
        ]),
        _c(
          "div",
          { staticClass: "header-right" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "mini", plain: "" },
                on: { click: _vm.handleEdit }
              },
              [_vm._v(_vm._s(_vm.$t("button.edit")))]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "mini", plain: "" },
                on: { click: _vm.handleAdd }
              },
              [_vm._v(_vm._s(_vm.$t("button.addPakinglotoa")))]
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "information" },
        [
          _c(
            "el-col",
            { staticStyle: { "margin-bottom": "10px" }, attrs: { span: 24 } },
            [
              _c("span", { staticStyle: { "font-size": "16px" } }, [
                _vm._v("基础信息")
              ])
            ]
          ),
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: { "label-position": "right", "label-width": "130px" }
            },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "小区名称" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.childData.areaName))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.garageName") } },
                    [_c("span", [_vm._v(_vm._s(_vm.childData.garageName))])]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "停车场编号" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.childData.garageNo))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "车位(总量)" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.childData.totalNumber))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "固定车位数" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.childData.fixedNumber))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "临时车位数" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.childData.temporaryNumber))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "停车场类型" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.childData.garageTypeName))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "联系人" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.childData.garagePerson))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "联系电话" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.childData.garageTelephone))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "厂商" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.childData.garageBrand))])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "是否允许临停" } }, [
                    _vm.childData.garageIsParking === 1
                      ? _c("span", [_vm._v("是")])
                      : _c("span", [_vm._v("否")])
                  ])
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.precinctAddr") } },
                    [_c("span", [_vm._v(_vm._s(_vm.childData.garageAddr))])]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-form-item", { attrs: { label: "备注" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.childData.garageRemark))])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }